import Logo from "@/components/tpr/Logo/Logo";
import TprIcon from "@/components/tpr/TprIcon/TprIcon";
import { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot } from "@/components/ui/input-otp";
import { REGEXP_ONLY_CHARS } from "input-otp";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

const MfaAlternative = () => {
  const [code, setCode] = useState("");
  const [, setDisabled] = useState(false);
  const [badCode, setBadCode] = useState(false);

  let navigate = useNavigate();
  let location = useLocation();
  let from = location.state?.from?.pathname || "/dashboard";

  useEffect(() => {
    if (badCode) {
      const timer = setTimeout(() => setBadCode(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [badCode]);

  const renderBadCode = () => {
    return (
      <>
        <div className="flex justify-center items-center mx-auto">
          <div
            className="mt-8 p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800"
            role="alert"
          >
            Invalid code.
          </div>
        </div>
      </>
    );
  };

  const handleOTPChange = (value: string) => {
    setCode(value);
  };

  const handleSubmit = (code: string) => {
    setDisabled(true);
    // Logic to verify the code goes here
    console.log("Submitted code:", code);

    if (code.toUpperCase() !== "AAAAAA") {
      setBadCode(true);
      setCode("");
      return false;
    }

    // On successful verification, navigate to the main app (e.g., dashboard)
    navigate(from, { replace: true });
  };

  return (
    <div>
      <div className="bg-white dark:bg-gray-900">
        <div className="flex justify-center h-screen">
          <div
            className="hidden bg-cover lg:block lg:w-2/3"
            style={{
              backgroundImage: `url("https://hopskotch.s3.eu-west-2.amazonaws.com/splashback/PhotoReal_abstract_pastel_oil_painting_sea_splash_sharpen_line_1.jpg")`,
              backgroundPosition: "50% 50%",
            }}
          ></div>

          <div className="flex items-center w-full max-w-md px-6 mx-auto lg:w-3/6">
            <div className="flex-1">
              <div className="text-center flex flex-col justify-center items-center">
                <div className="mb-4">
                  <TprIcon size="large" />
                </div>
                <h2 className="text-4xl font-bold text-center text-gray-700 dark:text-white">
                  <Logo color="black" size="large" />
                </h2>

                <p className="mt-3 text-gray-500 dark:text-gray-300">
                  We have sent a code to your email address. Please enter it below to continue.
                </p>
              </div>

              <div>{badCode && renderBadCode()}</div>

              <div className="mt-8 flex flex-col justify-center items-center">
                <InputOTP
                  maxLength={6}
                  pattern={REGEXP_ONLY_CHARS}
                  onComplete={handleSubmit}
                  onChange={handleOTPChange}
                  value={code}
                >
                  <InputOTPGroup>
                    <InputOTPSlot index={0} autoFocus tabIndex={0} className="uppercase" />
                    <InputOTPSlot index={1} className="uppercase" />
                    <InputOTPSlot index={2} className="uppercase" />
                  </InputOTPGroup>
                  <InputOTPSeparator />
                  <InputOTPGroup>
                    <InputOTPSlot index={3} className="uppercase" />
                    <InputOTPSlot index={4} className="uppercase" />
                    <InputOTPSlot index={5} className="uppercase" />
                  </InputOTPGroup>
                </InputOTP>
              </div>

              <div className="mt-8 flex flex-col justify-center items-center gap-2">
                <a href="/login" className="text-sm text-blue-800 hover:underline hover:text-blue-900">
                  Back to login
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MfaAlternative;
